/** @jsxImportSource @emotion/react */
import React, { FC, useEffect } from "react";
import { Text } from "../../components/general/Text";
import { css } from "@emotion/react";
import { FlexContainer } from "../../containers/FlexContainer";
import { GlobalStore } from "../../store/global/GlobalStore";
import { ReactComponent as BebopLogo } from "./icons/bebop.svg";
import Eyes from "./icons/Eyes.png";
import { RainbowKitWalletButton } from "../../components/Header/ConnectWallet/RainbowKitWalletButton";
import { useUpdateAddressWithENS } from "../../hooks/useUpdateAddressWithENS";
import { Link, useNavigate } from "react-router-dom";
import { useWaitlistStatus } from "./utils/useWaitlistStatus";
import { WaitlistStatus } from "./utils/allowListUtils";
import { useAccount } from "wagmi";
import { NAV_LINKS } from "config/consts";

export const EarlyLook: FC = () => {
  useUpdateAddressWithENS();
  const theme = GlobalStore.useState(s => s.theme);
  const address = GlobalStore.useState(s => s.address);
  const status = useWaitlistStatus();
  const navigate = useNavigate();
  const { isConnecting, isReconnecting } = useAccount();

  useEffect(() => {
    if (address && status?.waitlistStatus !== WaitlistStatus.NOT_IN_WAITLIST) {
      navigate("/waitlist");
    }
  }, [address, navigate, status]);

  useEffect(() => {
    if (address && status?.waitlistStatus === WaitlistStatus.ACCEPTED) {
      navigate("/trade");
    }
  }, [address, navigate, status]);

  if (isConnecting || isReconnecting) {
    return <></>;
  }

  return (
    <div
      css={css`
        width: 100%;
        height: 100vh;
        min-height: 750px;
        background-color: black;
        padding-left: 15px;
        padding-right: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      `}
    >
      <FlexContainer
        css={css`
          background-color: black;
          flex-direction: column;
          justify-content: flex-start;
          padding-left: 10px;
          padding-right: 10px;
        `}
      >
        <Text
          shouldScale={false}
          textStyle={"Header"}
          size={"Behemoth"}
          textCss={css`
            font-size: 10cqw;
            font-weight: 800;
            gap: 21px;
            text-align: center;
            line-height: 80%;
          `}
        >
          We’ve got a beta.
        </Text>{" "}
        <Text
          shouldScale={false}
          textStyle={"Header"}
          size={"Behemoth"}
          textCss={css`
            font-size: 10cqw;
            font-weight: 800;
            gap: 21px;
            text-align: center;
            line-height: 80%;
          `}
        >
          Want an early look?{" "}
        </Text>
        <img
          src={Eyes}
          alt={"Bebop Eyes"}
          css={css`
            max-width: 80%;
            margin: 6% 0;
          `}
        />
        <div
          css={css`
            max-width: 525px;
          `}
        >
          <Text
            textStyle={"Title"}
            size={"Large"}
            shouldScale={false}
            textCss={css`
              text-align: center;
            `}
          >
            A new trading experience is coming!
          </Text>
        </div>
        <div
          css={css`
            margin-top: 27px;
          `}
        >
          <RainbowKitWalletButton
            showIcon={false}
            buttonText={`Connect wallet to join waitlist`}
            buttonCss={css`
              width: 310px;
              height: 62px;
              justify-content: center;
              font-size: 18px;
              font-weight: 500;
            `}
          />
        </div>
        <FlexContainer
          css={css`
            margin-top: 20px;
          `}
        >
          <Text
            textStyle={"Button"}
            size={"Extra Large"}
            color={theme.font.secondary.default}
            shouldScale={false}
          >
            Have access?{"  "}
          </Text>
          <Text
            shouldScale={false}
            textStyle={"Button"}
            size={"Extra Large"}
            color={theme.font.link.default}
            textCss={css`
              display: inline-block;
              margin-left: 5px;
            `}
          >
            <RainbowKitWalletButton
              showIcon={false}
              buttonText={`Enter the beta`}
              buttonCss={css`
                width: 120px;
                padding: 0;
                height: 20px;
                justify-content: center;
                background-color: transparent;
                color: ${theme.font.link.default};
                font-size: 18px;
                font-weight: 500;
                &:hover {
                  background-color: transparent;
                  text-decoration: underline;
                }
              `}
            />
          </Text>
        </FlexContainer>
        <Link to={NAV_LINKS.BEBOP}>
          <BebopLogo
            css={css`
              margin-top: 45px;
            `}
          />
        </Link>
      </FlexContainer>
    </div>
  );
};
